import React from 'react'
import PopUp from '../../../ui/PopUp/PopUp'
import Button from '../../../ui/Button/Button'
import XLSFeedCatalogPanel from './XLSFeedCatalogPanel'
import './XLSFeedPopUp.sass'

const FEED_TITLES = {
  premium: 'XLS Feed — Premium каталог',
  outlet: 'XLS Feed — Outlet каталог',
}

function XLSFeedPopUp({ show, variant, brandId, onClose }) {
  if (!show || !variant) {
    return null
  }

  return (
    <PopUp
      show
      close={onClose}
      title={FEED_TITLES[variant] || 'XLS Feed'}
      className="XLSFeedPopUp"
      customButtons={[
        <Button key="close" onClick={onClose} title="Закрити" theme="bounded" border="gray" color="gray" />,
      ]}
    >
      <div className="XLSFeedPopUp-Content">
        <XLSFeedCatalogPanel catalog={variant} brandId={brandId} />
      </div>
    </PopUp>
  )
}

export default XLSFeedPopUp
